import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 20px;
  height: calc(100vh - 260px);
  overflow-y: auto;
`
